<template>
  <header
    class="fixed h-[78px] z-10 left-0 pt-0 right-0 pr-[1rem] lg:pr-[1rem] pb-0 pl-[1rem] lg:pl-[2rem] top-0 w-full bg-primary-500 dark:bg-primary-900 shadow p-4 flex justify-between items-center gap-4"
  >
    <div class="flex flex-row items-center gap-x-2 md:gap-x-4 shrink-0">
      <HealthButton
        icon="heroicons:bars-3-bottom-left-16-solid"
        color="transparent"
        class="lg:hidden block !px-1"
        @click.stop="toggleFixed"
      />
      <RouterLink to="/exams" class="shrink-0">
        <div class="lg:ml-[6rem] ml-0 flex flex-row items-center gap-2">
          <HealthLogo :width="width" />
          <div class="hidden sm:block mt-[9.3px] md:mt-5 shrink-0">
            <p class="text-6xs font-medium text-neutral-100 dark:text-neutral-100">
              {{ systemInfo.version ?? 0 }}
            </p>
          </div>
        </div>
      </RouterLink>
    </div>

    <section class="flex items-center gap-x-2 md:gap-x-4 overflow-hidden">
      <ChangeInstitution class="flex shrink min-w-0" />

      <div class="hidden md:block h-8 w-px bg-white/20 shrink-0"></div>

      <div class="hidden md:flex flex-row gap-2 shrink-0">
        <ChangeAppearance />
        <Notifications />
      </div>

      <div class="hidden md:block h-8 w-px bg-white/20 shrink-0"></div>

      <LoggedUser class="shrink-0" />
    </section>
  </header>
</template>

<script setup lang="ts">
  import { computed, onMounted } from "vue";
  import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
  import { getSystemInfoController } from "@/app/system/controllers/getSystemInfoController";
  import { useSidebar } from "@/shared/composables/useSidebar";
  import ChangeAppearance from "@/app/header/change_appearance/ChangeAppearance.vue";
  import HealthLogo from "@/shared/components/utils/HealthLogo.vue";
  import ChangeInstitution from "@/app/header/change_institution/ChangeInstitution.vue";
  import LoggedUser from "@/app/header/logged_user/LoggedUser.vue";
  import Notifications from "@/app/header/notifications/components/Notifications.vue";
  import HealthButton from "@/shared/components/utils/button/HealthButton.vue";

  const { data: systemInfo, request: getSystemInfo } = getSystemInfoController();

  const { toggleFixed } = useSidebar();

  const breakpoints = useBreakpoints(breakpointsTailwind);

  const mdAndSmaller = breakpoints.smallerOrEqual("md");

  const width = computed(() => {
    return mdAndSmaller.value ? "120" : "210";
  });

  onMounted(getSystemInfo);
</script>
